import type { Signal } from '@angular/core';
import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { CaseInvestigation, CreateCaseInvestigation } from '../../features/variance-tracker/case-investigation/models/case-investigation.models';
import type { EmployeeVarianceManagementRow } from '../../features/variance-tracker/components/employee-variance-management/models/employee-variance-management-row.model';
import type { TableDataResponse } from '../../features/variance-tracker/services/variance-tracker-mock.service';
import type { TableQuery } from '../../shared/components/generic-table/models/table-query.model';

export interface IncidentsQueryContext {
  readonly userId: string;
  readonly organizationId: string;
}

export interface EmployeeVarianceManagerClient {
  readonly options: Signal<{ label: string; value: string }[]>;
  getVarianceManagementRows(query: TableQuery, context: IncidentsQueryContext): Observable<TableDataResponse<EmployeeVarianceManagementRow>>;
  createCaseInvestigation(caseInvestigation: CreateCaseInvestigation): Observable<CaseInvestigation>;
}

export const EMPLOYEE_VARIANCE_MANAGER_CLIENT = new InjectionToken<EmployeeVarianceManagerClient>('EMPLOYEE_VARIANCE_MANAGER_CLIENT');
